/**
 * @Constant for Product Offering.
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 * Mapping Keys for AEM to UI to resolve component types
 */
/** */

export const PLAN_PRODUCT_CONSTANTS = {
  TARGET: 'target',
  TRUE: 'TRUE',
  TOURIST: 'tourist',
};
